import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M27.58 14.354v-2.66a2.693 2.693 0 0 1 4.662-1.838l8.913 9.55a3.142 3.142 0 0 1 .003 4.284l-8.921 9.59a2.693 2.693 0 0 1-4.665-1.84l.006-2.74a25.89 25.89 0 0 0-18.952 9.255l-1.023 1.221c-.536.64-1.578.267-1.586-.567L6 37.038C5.88 24.85 15.481 14.83 27.58 14.354Z"
    }
  )
);
var SvgForwardFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ForwardFilled_default = SvgForwardFilled;

export { ForwardFilled_default as default };
